export interface CancelState { canceled: boolean; }

type OmitFirstArg<F> = F extends (x: any, ...args: infer P) => infer R ? (...args: P) => R : never;

export function cancelPrevious<T extends (cancelState: CancelState, ...args: any[]) => any>(fn: T): OmitFirstArg<T> {
    let state: CancelState = { canceled: false };
    return function (...args: any[]) {
        state.canceled = true;
        const innerState = state = { canceled: false };
        return fn(innerState, ...args);
    } as any;
}
